
import React, { useState, useEffect } from 'react';
import './Home.css';
import Avatar from '../assets/avatar.png'
import Sign from '../assets/av_with_sign.png'
import v1 from '../assets/vector/v1.png'
import v2 from '../assets/vector/v2.png'
import v3 from '../assets/vector/v3.png'
import v4 from '../assets/vector/v4.png'
import ImageSlider from '../components/ImageSlider';
import HeroSection from '../components/HeroSection';
import ServiceSection from '../components/ServiceSection';
import { Link } from 'react-router-dom';
import TestimonialSlider from '../components/TestimonialSlider';
const Home = () => {
  const [activeCard, setActiveCard] = useState(0);
  const [activeFAQ, setActiveFAQ] = useState(null);

  useEffect(() => {
    // Animate cards on scroll
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in-up');
        }
      });
    }, observerOptions);

    const animatedElements = document.querySelectorAll('.animate-on-scroll');
    animatedElements.forEach(el => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const stats = [
    { number: "600K+", label: "Followers on socials" },
    { number: "29K", label: "Students in VIP community" },
    { number: "7+", label: "Successful years of trading" }
  ];

  const socialStats = [
    { icon: "/assets/icons/youtube-colored.png", link: "https://www.youtube.com/@meharshbhagat", subs: "350K+", label: "SUBSCRIBERS" },
    { icon: "/assets/icons/instagram-colored.png", link: "https://insta.openinapp.co/ccxw1", subs: "70K+", label: "FOLLOWERS" },
    { icon: "/assets/icons/telegram-colored.png", link: "telegram.openinapp.co/i1n51 ", subs: "115K+", label: "SUBSCRIBERS" },
  ]

  const problems = [
    {
      title: "Zero Guidance",
      description: "Trading blindly without trusted  mentorship.",
      icon: <img style={{ width: "48px", height: "48px" }} src={v1}></img>
    },
    {
      title: "Lack Of Confluence",
      description: "No supporting factor between signals & strategy.",
      icon: <img style={{ width: "48px", height: "48px" }} src={v2}></img>
    },
    {
      title: "Emotional Discipline",
      description: "Trades powered by feeling, not plans.",
      icon: <img style={{ width: "48px", height: "48px" }} src={v3}></img>
    },
    {
      title: "Missing The Circle",
      description: "No access to right mindset people.",
      icon: <img style={{ width: "48px", height: "48px" }} src={v4}></img>
    }
  ];

  const services = [
    {
      title: "Access To Inner Circle",
      description: "Unlock private access to my core strategies, tools, and trader ecosystem.",
      imagePath: "/assets/discord-2.jpg",
      imageAlt: "Inner Circle Discord Interface"
    },
    {
      title: "Live Market Updates",
      description: "Stay ahead with real-time insights, setups & scanner-based alerts.",
      imagePath: "/assets/discord-3.jpg",
      imageAlt: "Live Market Updates Interface"
    },
    {
      title: "Early Access To Our Products",
      description: "Be the first to access unreleased systems, upgrades, and high-performance tools.",
      imagePath: "/assets/discord-4.jpg",
      imageAlt: "Early Access Products Interface"
    }
  ];

  const faqItems = [
    {
      question: "What does Harsh Bhagat really do?",
      answer: "Harsh Bhagat is India's leading trader, investor, and strategy architect who builds high-performance trading systems and mentors traders to achieve consistent profitability."
    },
    {
      question: "Why do so many people follow you?",
      answer: "Because I provide real, tested trading systems based on scientific approach rather than emotions, and create a supportive community for traders to succeed together."
    },
    {
      question: "What's your mission in this space?",
      answer: "To create India's most self-reliant trading community by teaching proper systems and strategies instead of following market trends blindly."
    },
    {
      question: "How can I get started with your content?",
      answer: "Join our Inner Circle to get access to exclusive strategies, tools, live market updates, and connect with our trader ecosystem."
    },
    {
      question: "Still Need Help?",
      answer: "Contact our support team at harshcares@gmail.com or call +91 8188988788. We're here to help you succeed in your trading journey."
    }
  ];

  const toggleFAQ = (index) => {
    setActiveFAQ(activeFAQ === index ? null : index);
  };

  const handleDownloadClick = (id)=>{

    const el = document.getElementById(id);
    if (!el) return;
    const headerEl = document.querySelector('header.header');
    const offset = headerEl ? headerEl.offsetHeight : 0;
    const y = el.getBoundingClientRect().top + window.scrollY - offset - 4;
    window.scrollTo({ top: y, behavior: 'smooth' });
  
  }

  return (
    <div className="home-page">
      {/* Hero Section */}
      <div id="about">

        <HeroSection />
      </div>

      {/* Main Content Section */}
      <section className="main-section">

        <div className="container">
          <div className='main-content'>
            <div className="content-left">
              <div className="community-text">We foster the biggest stock community in india</div>
            </div>
            <div className="content-center stats-container">
              {stats.map((stat, index) => (
                <div key={index} className="stat-item">
                  <div className="stat-number large-stat">{stat.number}</div>
                  <div className="stat-label">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
          <div className="animate-on-scroll question-content" id="why">


            <div className="content-left" >
              <h2 className="main-title">
                So, you want to know <span className='line-through-trading'>trading? </span><br />
                <span className="accent-text">profitable trading? 👀</span>
              </h2>



              <p className="main-description" >
                The truth is, 90% traders lose money. Not because markets are tough,
                but because their approach is wrong.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Problems Section */}
      <section id="why" className="problems-section">
        <div className="container">
          <h2 className="section-title text-center animate-on-scroll">
            Why Most Traders in India <span className='fail'>Fail?</span>
          </h2>

          <div className="problems-grid animate-on-scroll">
            {problems.map((problem, index) => (
              <div key={index} className="problem-card ">
                <div className="problem-icon">{problem.icon}</div>
                <h3 className="problem-title">{problem.title}</h3>
                <p className="problem-description">{problem.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section id="story" className="story-section bg-gradient">
        <div className="container">
          <div className="story-content animate-on-scroll">
            <div className="story-header">
              <span className="story-label">HARSH BHAGAT's STORY</span>
              <h2 className=" change ">This is what I wanted to change...</h2>
            </div>

            <div className="story-grid">
              <div className="story-image">
                {/* <div className="story-image-placeholder"> */}
                {/* Story profile image - 558x529px */}
                <img className='' src={Sign} alt="Profile Image" />

                {/* <span className="image-label">Story Profile<br />558×529px</span> */}
                {/* </div> */}
                {/* <div className="signature script-font">Harsh<br />Bhagat</div> */}
              </div>

              <div className="story-text">
                <p className="large-body text-white">
                  I started as a trader, confused and overloaded. Tried 50 indicators. Lost money. Blamed the market.
                </p>
                <p className="large-body text-white">
                  Then I realized: You don't need more tools. You need the right system.
                </p>
                <p className="large-body text-white">
                  So I built it. And I tested it — across market cycles, asset classes, and volatility.
                </p>
                <p className="large-body text-white">
                  Now, I share this clarity with thousands of traders via:<br />
                  - My own app (Harshflixx)<br />
                  - Structured systems built from real-time price behaviour<br />
                  - India's fastest-growing premium trading community
                </p>
                <div className="story-stats">
                  {socialStats.map((stat, index) => (
                    <div key={index} className="story-stat-card">
                      <Link to={stat.link} target="_blank" targer="_blank" rel="noopener noreferrer" className='link'>
                        <div className="youtube-icon">
                          <img src={stat.icon} alt=" Icon" />

                        </div>
                        <div className="stat-number">{stat.subs}</div>
                        <div className="stat-label">{stat.label}</div>
                      </Link>

                    </div>
                  ))}
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>

      {/* Testimonial Section */}

      <TestimonialSlider />


      {/* CTA Section */}
      < section className="cta-section" >
        <div className="container">
          <div className="cta-content animate-on-scroll">
            <h2 className="cta-question section-title">
              Do you really need to <b >stress, loose your sleep </b>  over a bad trade to be successful in trading?
            </h2>

            <div className="cta-grid">
              <div className="cta-image">

                {/* CTA profile image - 709x502px */}
                <img className="image-label" src='./assets/cta_image.png' alt='cta-profile' />
                {/* <span className="image-label">Profile<br />709×502px</span> */}

              </div>

              <div className="cta-text">
                <p className="large-body">
                  No. You need a system. You need science. You need support.
                </p>
                <p className="large-body">
                  That's what we built at Harshflixx — the only platform where you learn,
                  implement, and grow inside one ecosystem.
                </p>

                <button className="btn btn-primary cta-button" onClick={() =>handleDownloadClick("footer-banner")}>
                  Download Harshflixx App
                  {/* <span className="crown-icon">👑</span> */}
                  < img src="./assets/icons/crown.svg" alt="crown" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section >

      {/* Summit Section */}
      < section className="summit-section" >

        <div className="summit-content animate-on-scroll">
          <ImageSlider />
          <h2 className="Summit_text text-center">The Day We Made History <span>
            - Harshflixx Summit
          </span>
          </h2>


        </div>
      </section >

      {/* <ServiceSection/> */}
      <div id="resources">
        <ServiceSection />

      </div>


      {/* FAQ Section */}
      < section className="faq-section" >
        <div className="container">
          <div className="faq-content">

            <div className="faq-list">
              <h2 className="faq-title  animate-on-scroll">People also ask us</h2>
              {faqItems.map((item, index) => (
                <div key={index} className="faq-item animate-on-scroll">
                  <button
                    className="faq-question"
                    onClick={() => toggleFAQ(index)}
                    aria-expanded={activeFAQ === index}
                  >
                    <span>{item.question}</span>
                    <span className={`faq-arrow ${activeFAQ === index ? 'active' : ''}`}>
                      <img src='./assets/icons/down-arrow.png' alt='down-arrow' />
                    </span>
                  </button>
                  {activeFAQ === index && (
                    <div className="faq-answer">
                      <p>{item.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section >
    </div >
  );
};

export default Home;
